/*
 * 人员管理
 * */
import request from './.request'

/**
 * 查询某个公司内的人员，支持分页
 * @param {number} entrId 公司id
 * @param {object} params 其他参数，包括分页参数，目前只支持分页参数
 * @returns 
 */
export function personSearch(entrId, params) {
  return request({
    url: `/person/${entrId}?by=enterprise`,
    method: 'get',
    params: params
  })
}
export function personAdd(e) {
  return request({
    url: '/person',
    method: 'post',
    data: e
  })
}
export function personUpdate(e) {
  return request({
    url: '/person',
    method: 'put',
    data: e
  })
}
export function personUpdateRole(id, e) {
  return request({
    url: `/person/${id}?about=role`,
    method: 'put',
    data: e
  })
}
export function personUpdateMeno(id, profile) {
  return request({
    url: `/person/${id}?about=profile`,
    method: 'put',
    data: profile
  })
}
export function personUpdatePwd(id, e) {
  return request({
    url: `/person/${id}?about=password`,
    method: 'put',
    data: e
  })
}
export function personDelete(id) {
  return request({
    url: `/person/${id}`,
    method: 'delete'
  })
}
export function userInfo(id) {
  return request({
    url: `/person/${id}`,
    method: 'get'
  })
}
export function personDateBy(e) {
  return request({
    url: `/person/`,
    method: 'get',
    params:e
  })
}
/**
 * 根据手机号查询
 * */
export function searchByphone(phone,id) {
  return request({
    url: `/person/${phone}?by=phone&of=enterprise&about=info-and-employ&entrId=${id}`,
    method: 'get',
  })
}

export function postPersonIdEnterEnterprise(form) {
  return request({
    url: `/person/?about=enterprise`,
    method: 'put',
    data: form
  })
}



// WEBPACK FOOTER //
// ./src/api/person.js